module.exports = __webpack_public_path__ + "static/media/BartLogo.bbbd64a8.png";